module.exports = __webpack_public_path__ + "static/media/unapproved-team-icon.a2006ae0.svg";